/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS } from '../utilities';
import './styles.scss';
import { Unit, checkIfValueIsValid } from '../common';

export const getExteriorData = (props) => {
  const { dataSet, objectText, getBooleanValues } = props;

  const factKey = FACTS_FIELD_KEYS.EXTERIOR;

  const exteriorData = dataSet[factKey] || {};

  const ExteriorFactsRow = ({
    facts,
    isYesNo = false,
    isDescription = false
  }) => {
    const areaFields = ['balconySurface', 'terraceSurface'];

    const Value = () => {
      if (isYesNo) {
        return getBooleanValues(facts?.value);
      } else {
        return (
          <>
            {facts?.value} <Unit areaFields={areaFields} facts={facts} />
          </>
        );
      }
    };
    const factFieldName = facts?.factFieldName;
    if (checkIfValueIsValid(facts?.value)) {
      if (isDescription) {
        return (
          <>
            <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
              <div className='object-listing-accordian-list-left'>
                {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
                  objectText?.[factKey]?.[factFieldName]?.label ||
                  facts?.factFieldName}
              </div>
              <div className='object-listing-accordian-list-right'></div>
            </div>

            <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
              <div className='common-descriptions-fact-body'>
                {facts?.value}
              </div>
            </div>
          </>
        );
      } else {
        return (
          <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
            <div className='object-listing-accordian-list-left'>
              {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
                objectText?.[factKey]?.[factFieldName]?.label ||
                facts?.factFieldName}
            </div>
            <div className='object-listing-accordian-list-right'>
              <Value />
            </div>
          </div>
        );
      }
    }

    return <></>;
  };

  const ExteriorSection = () => {
    return (
      <div className='exterior-data-body'>
        <ExteriorFactsRow
          key='pool'
          facts={{
            factFieldName: 'pool',
            value: exteriorData?.pool
          }}
          isYesNo={true}
        />

        <ExteriorFactsRow
          key='balcony'
          facts={{
            factFieldName: 'balcony',
            value: exteriorData?.balcony
          }}
          isYesNo={true}
        />
        <ExteriorFactsRow
          key='balconySurface'
          facts={{
            factFieldName: 'balconySurface',
            value: exteriorData?.balconySurface
          }}
        />
        <ExteriorFactsRow
          key='terrace'
          facts={{
            factFieldName: 'terrace',
            value: exteriorData?.terrace
          }}
          isYesNo={true}
        />
        <ExteriorFactsRow
          key='terraceSurface'
          facts={{
            factFieldName: 'terraceSurface',
            value: exteriorData?.terraceSurface
          }}
        />
        <ExteriorFactsRow
          key='descriptionOfPool'
          facts={{
            factFieldName: 'descriptionOfPool',
            value: exteriorData?.descriptionOfPool
          }}
          isDescription={true}
        />
        <ExteriorFactsRow
          key='descriptionTerraceAndBalcony'
          facts={{
            factFieldName: 'descriptionTerraceAndBalcony',
            value: exteriorData?.descriptionTerraceAndBalcony
          }}
          isDescription={true}
        />
      </div>
    );
  };

  return {
    component: <ExteriorSection />,
    factsCount: 0
  };
};
